import { useEffect } from 'react';
import { Layout } from '@/components/layout/Layout';

const Apply = () => {
  useEffect(() => {
    document.title = 'Apply Privately | Diamond Club Matchmaking';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Apply to join Diamond Club Matchmaking. Submit your application privately and confidentially.');
    }
  }, []);

  const smartMatchUrl = 'https://ideservelove.smartmatchapp.com/client/submissionform/13/default/';

  return (
    <Layout>
      <section className="min-h-screen bg-black-deep grain-overlay">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
          {/* Page Header */}
          <div className="text-center mb-10">
            <h1 className="font-serif text-display-sm md:text-display text-cream mb-4">
              Apply Privately
            </h1>
            <p className="font-sans text-cream-muted text-base md:text-lg max-w-2xl mx-auto">
              Complete the form below to begin your journey with Diamond Club Matchmaking. All submissions are confidential.
            </p>
          </div>
          
          {/* Iframe Container */}
          <div className="bg-white/[0.02] border border-gold/10 rounded-sm overflow-hidden">
            <iframe
              src={smartMatchUrl}
              title="Diamond Club Application Form"
              className="w-full border-0"
              style={{ minHeight: '1400px', height: '100%' }}
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
          </div>
          
          {/* Fallback Link */}
          <div className="text-center mt-6">
            <p className="font-sans text-cream-muted text-sm">
              If the form doesn't load,{' '}
              <a 
                href={smartMatchUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gold hover:text-gold-light underline underline-offset-4 transition-colors"
              >
                click here to apply
              </a>
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Apply;
